import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ImageSection from '../components/ImageSection';
import BusinessCoreSection from '../components/BusinessCoreSection';
import ProvenImpactSection from '../components/ProvenImpactSection';
import EcosystemSection from '../components/EcosystemSection';
import PhilosophySection from '../components/PhilosophySection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Game to Growth・遊戲化學習賦能成長"
        description="明悅文化 Ming Yue Culture（明悅心創）以遊戲化學習（Game-based Learning）打造高能動性 High Agency 賦能系統，陪伴全球企業、教練與新世代青年，透過財富流、明日之星、時空流三大模擬遊戲，解鎖理性能動性，活出富而喜悅的生命成長。"
        path="/"
      />
      <Header />
      <HeroSection />
      <AboutSection />
      <BusinessCoreSection />
      <ProvenImpactSection />
      <ImageSection />
      <EcosystemSection />
      <PhilosophySection />
      <Footer />
    </div>
  );
};

export default HomePage;
